export default class ContactWithoutBookingValidator
{
    constructor()
    {
        this.eventDelegation();
    }

    eventDelegation()
    {
        $("body").on("submit", "#select-chollo",  function (e) {
            let startDate = $(this).find('#no-booking-start-date');
            let endDate = $(this).find('#no-booking-end-date');

            if (startDate.length > 0 && endDate.length > 0) {
                let divErrorNotHaveDates = $('[data-entity="notHaveDates"]');

                if (!startDate.val() || !endDate.val()) {
                    divErrorNotHaveDates.show();
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    return false;
                }

                divErrorNotHaveDates.hide();
            }
        });
    }
}


